import React from 'react';
import './AboutSection.css';
import about from '../../assets/about.svg';

function AboutSection() {
  return (
    <section id="about" className="about-section">
      <div className="about-content">
        <div className="about-image-container">
          <img src={about} alt="Equipe e conexão VitaLink" className="about-image" />
          <div className="about-image-note">
            <strong>Rede local</strong>
            <span>instalação com cuidado e suporte próximo</span>
          </div>
        </div>

        <div className="about-text">
          <span className="about-kicker">Sobre a VitaLink</span>
          <h2 className="about-title">Conexão de alta velocidade com atendimento de verdade</h2>
          <p className="subtitle">
            A VitaLink conecta famílias e empresas com fibra óptica pura,
            estabilidade real e uma equipe que conhece a região.
          </p>

          <div className="about-stats">
            <div className="stat-card">
              <h3>100%</h3>
              <span>Fibra óptica</span>
            </div>
            <div className="stat-card">
              <h3>+1000</h3>
              <span>Clientes</span>
            </div>
            <div className="stat-card">
              <h3>24/7</h3>
              <span>Suporte local</span>
            </div>
          </div>

          <div className="about-description">
            <p>
              Entregamos internet para quem precisa de desempenho todos os dias:
              chamadas sem falhas, aulas online, jogos competitivos, filmes em 4K
              e dispositivos conectados ao mesmo tempo. O foco é simples:
              velocidade, estabilidade e confiança desde a contratação.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
